import { BaseModel } from './BaseModel';

export class Vimeo extends BaseModel {
  static get entity() {
    return 'vimeos';
  }

  static get fk() {
    return 'vimeo_id';
  }

  static fields() {
    return {
      id: this.uid(),
      upload_link: this.attr(null),
      video_id: this.attr(null),
      duration: this.attr(null),
      video_link: this.attr(null),
      thumbnail_link: this.attr(null),
      transcode_status: this.attr(null),
      upload_status: this.attr(null),
      status: this.attr(null),
      isVideoAvailable: this.attr(null),
      sourceFile: this.attr(null)
    };
  }

  static apiConfig = {
    actions: {
      getVimeoUploadLink(body) {
        return this.post(`/vimeo/upload`, body);
      },

      getVideoInformation(id, params) {
        return this.get(`/vimeo/inquiry/${id}`, { params });
      }
    }
  };
}

export default Vimeo;
